import dayjs from "dayjs";
import WorkOrderStatus from "../../components/WorkOrderStatus";
import { getTimeZoneAbbreviation } from "../../utils/getTimeZoneAbbreviation";
import useAuth from "../../hooks/useAuth";

const ScheduleCard = ({
  schedule,
  engineer, 
  status,
  tasks,
  timeLogs,
  subStatus,
}) => {
  const { authRole } = useAuth();
  const checkIn = tasks?.find((task) => task.taskType === "CHECK_IN");
  const checkOut = tasks?.find((task) => task.taskType === "CHECK_OUT");
  const onTheWay = tasks?.find((task) => task.taskType === "ON_THE_WAY");
  const runningLate = tasks?.find((task) => task.taskType === "RUNNING_LATE");

  const totalHours =
    timeLogs?.reduce((acc, timeLog) => acc + +timeLog.totalHours, 0) || null;

  return (
    <>
      {engineer && (status === "ASSIGNED" || status === "CONFIRM" || status === "INPROGRESS") ?
       (
         <SchedulePublishedCard
          title={
            schedule.scheduleType === "WORK_BETWEEN"
              ? "Work Between"
              : "Fixed Start"
          }
          scheduleType={schedule.scheduleType}
          startDate={schedule?.orderStartDate}
          startTime={schedule?.orderStartTime}
          timeZone={schedule.timeZone}
        />
      //   <>
      //     {subStatus === "ON_THE_WAY" ? (
      //       <OnTheWayCard
      //         task={onTheWay}
      //         timeZone={schedule?.timeZone}
      //         authRole={authRole}
      //       />
      //     ) : subStatus === "RUNNING_LATE" ? (
      //       <RunningLateCard
      //         task={runningLate}
      //         timeZone={schedule?.timeZone}
      //         authRole={authRole}
      //       />
      //     ) : (
      //       <ScheduleAssignedConfirmedCard
      //         authRole={authRole}
      //         status={subStatus}
      //         scheduleType={schedule?.scheduleType}
      //         startDate={schedule?.confirmedWorkOrderAt}
      //         startTime={schedule?.confirmedWorkOrderAt}
      //         timeZone={schedule?.timeZone}
      //       />
      //     )}
      //   </>
      ) 
      // :
      //  status === "INPROGRESS" ? (
      //   <CheckedInOutCard
      //     status={subStatus}
      //     startDateTime={checkIn?.completedTask.text}
      //     isCheckOut={checkOut.completedTask.isCompleted}
      //     endDateTime={checkOut.completedTask.text}
      //     timeZone={schedule.timeZone}
      //   />
      // ) 
      : status === "INCOMPLETE" ? (
        <ScheduleInCompleteCard title="Incomplete" totalHours={totalHours} />
      ) : status === "WORKDONE" && subStatus === "REVIEWED" ? (
        <ReviewedCard
          authRole={authRole}
        />
      ) : (
        <SchedulePublishedCard
          title={
            schedule.scheduleType === "WORK_BETWEEN"
              ? "Work Between"
              : "Fixed Start"
          }
          scheduleType={schedule.scheduleType}
          startDate={schedule?.orderStartDate}
          startTime={schedule?.orderStartTime}
          timeZone={schedule.timeZone}
        />
      )}
    </>
  );
};

export default ScheduleCard;

export function SchedulePublishedCard({
  title,
  startDate,
  startTime,
  timeZone,
}) {
  return (
    <div className="shadow-md rounded-md py-3 px-4 h-full min-h-0 lg:min-h-24  w-full bg-white">
      <div className="flex">
        <i className="fa-light fa-clock text-primary text-3xl"></i>
        <div className="ml-2 mt-2">
          <p className="font-normal text-dark">Schedule: {title}</p>
          <p className="mt-1 text-primary">
            {dayjs.utc(startDate).format("MM/DD/YYYY")}{" "}
            {dayjs.utc(startTime).format("h:mm A")} (
            {getTimeZoneAbbreviation(timeZone)})
          </p>{" "}
        </div>
      </div>
    </div>
  );
}

function ScheduleInCompleteCard({ title, totalHours }) {
  return (
    <div className="shadow-md rounded-md py-3 px-4 h-full min-h-0 lg:min-h-24  w-full">
      <div className="flex">
        <i className="fa-light fa-clock text-primary text-3xl"></i>
        <div className="ml-2 mt-2">
          {title === "Incomplete" ? (
            <div className="flex">
              <p className="font-normal text-dark text-sm mr-1">Status: </p>
              <WorkOrderStatus
                status="INCOMPLETE"
                className="!py-[1.5px] !w-[80px] !text-[9px]"
              />
            </div>
          ) : (
            <p className={`font-normal text-dark `}>
              Status: <span>{title}</span>
            </p>
          )}
          <p className="mt-1 text-primary">Working Hours:</p>
          <p className="text-primary">{totalHours?.toFixed(2)} Hours</p>{" "}
        </div>
      </div>
    </div>
  );
}

function ScheduleAssignedConfirmedCard({
  authRole,
  status,
  startDate,
  startTime,
  timeZone,
}) {
  return (
    <div className="shadow-md rounded-md py-3 px-4 h-full min-h-0 lg:min-h-24  w-full">
      <div className="flex">
        <i className="fa-solid fa-circle-info text-primary text-3xl"></i>
        {/* <i className="fa-light fa-clock text-primary text-3xl"></i> */}
        <div className="ml-2 mt-2">
          {status === "NOT_CONFIRMED" && (
            <>
              <div className="flex">
                <p className="font-normal text-dark text-sm mr-1">Status: </p>
                <WorkOrderStatus
                  status="NOT_CONFIRMED"
                  className="!py-[1.5px] !w-[80px] !text-[9px]"
                />
              </div>
              <p className=" mt-1 text-primary">
                {authRole === "FREELANCER"
                  ? "Confirm your task assignment"
                  : "Work Order has not been confirmed yet by provider"}
              </p>
            </>
          )}
          {status === "CONFIRMED" && (
            <>
              <div className="flex">
                <p className="font-normal text-dark text-sm mr-1">Status: </p>
                <WorkOrderStatus
                  status="CONFIRMED"
                  className="!py-[1.5px] !w-[80px] !text-[9px]"
                />
              </div>
              <p className=" mt-1 text-primary">
                {authRole === "FREELANCER"
                  ? "Mark your work Order ready to go 24 hours before schedule time"
                  : "Work Order has been confirmed by provider"}
              </p>
            </>
          )}

          {status === "READY_TO_GO" && (
            <>
              <div className="flex">
                <p className="font-normal text-dark text-sm mr-1">Status: </p>
                <WorkOrderStatus
                  status="READY_TO_GO"
                  className="!py-[1.5px] !w-[80px] !text-[9px]"
                />
              </div>
              <p className=" mt-1 text-primary">
                {authRole === "FREELANCER"
                  ? `Marked at: ${dayjs(startDate).format("DD/MM/YYYY")} 
                ${dayjs(startTime)
                  .tz(timeZone)
                  .format("hh:mm A")} (${getTimeZoneAbbreviation(timeZone)})`
                  : "Provider  is ready to go to attend the site"}
              </p>
            </>
          )}

          {status === "NOT_READY" && (
            <>
              <div className="flex">
                <p className="font-normal text-dark text-sm mr-1">Status: </p>
                <WorkOrderStatus
                  status="NO_READY"
                  className="!py-[1.5px] !w-[80px] !text-[9px]"
                />
              </div>
              <p className=" mt-1 text-primary">
                Mark your Work Order ready to go 24 hours before schedule time
              </p>
            </>
          )}

          {status === "CANCELLED" && (
            <>
              <div className="flex">
                <p className="font-normal text-dark text-sm mr-1">Status: </p>
                <WorkOrderStatus
                  status="CANCELLED"
                  className="!py-[1.5px] !w-[80px] !text-[9px]"
                />
              </div>
              {authRole === "FREELANCER" ? (
                <p className=" mt-1 text-primary">
                  You have canceled this work order, which will impact your
                  cancellation rate.
                </p>
              ) : (
                <p className=" mt-1 text-primary">
                  Engineer cancelled the work order.
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function CheckedInOutCard({ status, startDateTime, endDateTime, timeZone }) {
  return (
    <div className="shadow-md rounded-md py-3 px-4 h-full min-h-0 lg:min-h-24  w-full">
      <div className="flex">
        <i className="fa-solid fa-circle-info text-primary text-3xl"></i>
        {/* <i className="fa-light fa-clock text-primary text-3xl"></i> */}
        <div className="ml-2 mt-2">
          {status === "CHECK_OUT" && (
            <>
              <div className="flex">
                <p className="font-normal text-dark text-sm mr-1">Status: </p>
                <WorkOrderStatus
                  status="CHECK_OUT"
                  className="!py-[1.5px] !w-[80px] !text-[9px]"
                />
              </div>

              <p className="text-primary mt-1">
                Checked out at: <br />
                <span className="text-primary">
                  {dayjs(endDateTime).format("DD/MM/YYYY")} {""}
                </span>
                <span className="text-primary">
                  {dayjs(endDateTime).tz(timeZone).format("hh:mm A")}
                </span>
              </p>
              <p className="text-primary">
                ({getTimeZoneAbbreviation(timeZone)})
              </p>
            </>
          )}

          {status === "CHECK_IN" && (
            <>
              <div className="flex">
                <p className="font-normal text-dark text-sm mr-1">Status: </p>
                <WorkOrderStatus
                  status="CHECK_IN"
                  className="!py-[1.5px] !w-[80px] !text-[9px]"
                />
              </div>
              <p className="text-primary mt-1">
                at:
                <span className="text-primary ml-1">
                  {dayjs(startDateTime).format("DD/MM/YYYY")} {""}
                </span>
                <span className="text-primary">
                  {dayjs(startDateTime).tz(timeZone).format("hh:mm A")}{" "}
                </span>
              </p>
              <p className="text-primary">
                ({getTimeZoneAbbreviation(timeZone)})
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function OnTheWayCard({ task, timeZone, authRole }) {
  return (
    <div className="shadow-md rounded-md py-3 px-4 h-full min-h-0 lg:min-h-24  w-full">
      <div className="flex">
        <i className="fa-solid fa-circle-info text-primary text-3xl"></i>

        <div className="ml-2 mt-2">
          <div className="flex">
            <p className="font-normal text-dark text-sm mr-1">Status: </p>
            <WorkOrderStatus
              status="ON_THE_WAY"
              className="!py-[1.5px] !w-[80px] !text-[9px]"
            />
          </div>
          {authRole === "FREELANCER" ? (
            <p className=" mt-1 text-primary">
              Marked at: {dayjs(task?.completedTask?.text).format("DD/MM/YYYY")}
               {dayjs(task?.completedTask?.text).format("hh:mm A")} <br /> (
              {getTimeZoneAbbreviation(timeZone)})
            </p>
          ) : (
            <p className=" mt-1 text-primary">
              Provider is on the way to the work order location
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

function RunningLateCard({ task, timeZone, authRole }) {
  return (
    <div className="shadow-md rounded-md py-3 px-4 h-full min-h-0 lg:min-h-24  w-full">
      <div className="flex">
        <i className="fa-solid fa-circle-info text-primary text-3xl"></i>

        <div className="ml-2 mt-2">
          <div className="flex">
            <p className="font-normal text-dark text-sm mr-1">Status: </p>
            <WorkOrderStatus
              status="RUNNING_LATE"
              className="!py-[1.5px] !w-[80px] !text-[9px]"
            />
          </div>
          {authRole === "FREELANCER" ? (
            <p className=" mt-1 text-primary">
              Marked at: {dayjs(task?.completedTask?.text).format("DD/MM/YYYY")}
               {dayjs(task?.completedTask?.text).format("hh:mm A")} <br /> (
              {getTimeZoneAbbreviation(timeZone)})
            </p>
          ) : (
            <p className=" mt-1 text-primary">Provider is running late</p>
          )}
        </div>
      </div>
    </div>
  );
}

function ReviewedCard({ authRole }) {
  return (
    <div className="shadow-md rounded-md py-3 px-4 h-full min-h-0 lg:min-h-24  w-full">
      <div className="flex">
        <i className="fa-solid fa-circle-info text-primary text-3xl"></i>

        <div className="ml-2 mt-2">
          <div className="flex">
            <p className="font-normal text-dark text-sm mr-1">Status: </p>
            <WorkOrderStatus
              status="REVIEWED"
              className="!py-[1.5px] !w-[80px] !text-[9px]"
            />
          </div>
          {authRole === "CLIENT" && (
            <p className=" mt-1 text-primary">
              Provider has reviewed the work order
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
